import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import s from "./ApprovedProjects.module.scss";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import ProjectItem from "../../components/ProjectItem/ProjectItem";
import Projects from "../Projects/Projects";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getApprovedProjectDetails } from "../../redux/ApplicationSlice";

const ApprovedProjects = () => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const projects = useSelector((state) => state.application.approvedProjects);

  return (
    <div>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.approved_projects}>
        <div className={s.projects_wrapper}>
          <Header />
          <div className={s.projects}>
            <h2 className={s.h2}>{t("approvedProjects")}</h2>
            <div className={s.content}>
              {projects?.map((project) => (
                <Link
                  to={`/project/${project.id}`}
                  onClick={() =>
                    dispatch(getApprovedProjectDetails(project.id))
                  }
                >
                  <ProjectItem project={project} />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default ApprovedProjects;
